import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthLayoutComponent } from './shared/components/layouts/auth-layout/auth-layout.component';
import { MenuLayoutComponent } from './shared/components/layouts/menu-layout/menu-layout.component';
import { RedirectLoginGuard } from './shared/guards/redirect-login.guard';
import { AuthGuard } from './shared/guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    canActivate: [RedirectLoginGuard],
    component: AuthLayoutComponent,
    pathMatch: 'full'
  },
  {
    path: 'pessoas',
    canActivate: [AuthGuard],
    component: MenuLayoutComponent,
    loadChildren: () =>
      import('./views/persons/persons.module').then(m => m.PersonsModule),
    data: { title: 'Pessoas', breadcrumb: 'Pessoas' },
  },
  {
    path: 'organizacoes',
    canActivate: [AuthGuard],
    component: MenuLayoutComponent,
    loadChildren: () =>
      import('./views/organizations/organizations.module').then(
        m => m.OrganizationsModule,
      ),
    data: { title: 'Organizações', breadcrumb: 'Organizações' },
  },
  {
    component: AuthLayoutComponent,
    canActivate: [],
    path: 'sessions',
    loadChildren: () =>
      import('./views/sessions/sessions.module').then(
        m => m.SessionsModule,
      ),
    data: { title: 'Session' },
  },
  // {
  //   path: '**',
  //   redirectTo: 'sessions/404',
  // },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
